export function maskMatricula (value) {
  if (value) {
    //123456 12 12 1234 1 12345 123 1234567 12
    let mask = `###### ## ## #### # ##### ### ####### ##`
    const arr = value.split("")
    arr.forEach(arr => {
      mask = mask.replace('#', arr)
    })

    return mask
  } else {
    return "Matrícula não informada"
  }
}
